import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import img1 from "../../Assets/portfolio/portfolio-1.jpeg";
import img2 from "../../Assets/portfolio/portfolio-2.jpeg";
import img3 from "../../Assets/portfolio/portfolio-3.jpeg";
import img4 from "../../Assets/portfolio/portfolio-4.jpeg";
import img5 from "../../Assets/portfolio/portfolio-5.jpeg";
import img6 from "../../Assets/portfolio/portfolio-6.jpeg";
import img7 from "../../Assets/portfolio/portfolio-7.jpeg";
import img8 from "../../Assets/portfolio/portfolio-8.jpeg";
import img9 from "../../Assets/portfolio/portfolio-9.jpeg";
import img10 from "../../Assets/portfolio/portfolio-10.jpeg";

const miningPortfolio = [
  {
    id: 1,
    title: "High-Grade Limestone Quarry",
    category: "Construction Materials",
    location: "Madhya Pradesh, India",
    description:
      "Large-scale extraction of high-quality limestone supplying major cement manufacturing plants.",
    image: img1,
  },
  {
    id: 2,
    title: "Bauxite Mining & Refining",
    category: "Aluminum Resources",
    location: "Odisha, India",
    description:
      "Sustainable bauxite mining operation supporting aluminum refineries with modern environmental practices.",
    image: img2,
  },
  {
    id: 3,
    title: "Granite Stone Quarry",
    category: "Stone Resources",
    location: "Tamil Nadu, India",
    description:
      "Extraction of premium granite blocks for export and large infrastructure projects.",
    image: img3,
  },

  {
    id: 4,
    title: "Open Cast Bauxite Mine",
    category: "Aluminum Resources",
    location: "Jharkhand, India",
    description:
      "Efficient open-cast mining with minimal environmental impact and high output.",
    image: img4,
  },
  {
    id: 5,
    title: "Marble Quarry Project",
    category: "Stone Resources",
    location: "Rajasthan, India",
    description:
      "Mining and processing of high-quality marble for construction and export.",
    image: img5,
  },
  {
    id: 6,
    title: "Cement Grade Limestone Mine",
    category: "Construction Materials",
    location: "Andhra Pradesh, India",
    description:
      "Dedicated limestone mine supplying raw materials to large cement plants.",
    image: img6,
  },
  {
    id: 7,
    title: "Dolomite & Limestone Quarry",
    category: "Construction Materials",
    location: "Odisha, India",
    description:
      "Combined extraction of dolomite and limestone for industrial applications.",
    image: img7,
  },

  {
    id: 8,
    title: "Sandstone Quarry",
    category: "Stone Resources",
    location: "Rajasthan, India",
    description:
      "Extraction of sandstone for construction, paving, and decorative use.",
    image: img8,
  },
  {
    id: 9,
    title: "Granite Block Extraction Project",
    category: "Stone Resources",
    location: "Andhra Pradesh, India",
    description:
      "High-volume granite extraction for export-grade stone blocks.",
    image: img9,
  },
  {
    id: 10,
    title: "Eco-Friendly Bauxite Mining",
    category: "Aluminum Resources",
    location: "Maharashtra, India",
    description:
      "Environmentally responsible bauxite mining with land reclamation initiatives.",
    image: img10,
  },
];

const PortfoioHero = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500); // simulate API delay
  }, []);

  const SkeletonCard = () => {
    return (
      <div className="animate-pulse rounded-2xl overflow-hidden shadow-lg bg-[#f9f4f0] flex flex-col md:flex-row">
        {/* Image Skeleton */}
        <div className="md:w-1/2 h-64 bg-gray-300"></div>

        {/* Content Skeleton */}
        <div className="p-6 md:w-1/2 flex flex-col justify-between">
          <div>
            <div className="h-6 w-32 bg-gray-300 rounded mb-3"></div>
            <div className="h-5 w-3/4 bg-gray-300 rounded mb-4"></div>
            <div className="h-3 w-full bg-gray-300 rounded mb-2"></div>
            <div className="h-3 w-5/6 bg-gray-300 rounded"></div>
          </div>

          <div className="h-4 w-1/2 bg-gray-300 rounded mt-6"></div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full px-4 py-10 sm:py-16 sm:px-8 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto ">
        {/* Header */}
        <div className="flex flex-col items-center mb-10">
          <p className="text-xs font-bold tracking-[0.22em] font-krona uppercase text-gray-500 border-b-2 border-red-600 pb-0.5 mb-3">
            PORTFOLIO
          </p>
          <h2 className="text-xl md:text-4xl lg:text-[45px] font-krona font-bold text-gray-900 tracking-wider">
            Our Recent Projects
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 text-center">
          {loading
            ? Array(6)
                .fill(0)
                .map((_, index) => <SkeletonCard key={index} />)
            : miningPortfolio.map((item, index) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="group relative rounded-2xl overflow-hidden shadow-lg bg-[#f9f4f0] flex flex-col md:flex-row"
                >
                  {/* Image */}
                  <div className="overflow-hidden md:w-1/2">
                    <img
                      src={item.image}
                      alt={item.title}
                      loading="lazy"
                      className="w-full h-64 object-cover transform group-hover:scale-110 transition duration-500"
                    />
                  </div>

                  {/* Content */}
                  <div className="p-6 flex flex-col justify-between md:w-1/2">
                    <div>
                      <p className="bg-[#e33b28] inline-block px-4 py-2 text-sm sm:text-base text-white rounded-lg">
                        {item.category}
                      </p>
                      <h1 className="text-base  font-krona font-semibold  mt-3">
                        {item.title}
                      </h1>
                      <p className="text-xs sm:text-xs font-krona tracking-wide mt-6">
                        {item.description}
                      </p>
                    </div>

                    <p className="font-krona text-sm text-gray-600 mt-4">
                      {item.location}
                    </p>
                  </div>
                </motion.div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default PortfoioHero;
